export const acceptedMimeTypes = ["image/jpeg", "image/png", "image/jpg"];
export const MAX_IMAGE_SIZE = 3 * 1024 * 1024;
export const DATE_FORMAT = "MM/DD/YYYY";
export const DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm:ss A";
// Variant counts at or below this are highlighted as low stock on the shop.
export const LOW_STOCK_THRESHOLD = 5;
